export { default as News } from './news/screen/News';
export { default as UpdateNews } from './news/screen/UpdateNews';

export { default as RegisterNews } from './register_news/screen/RegisterNews';

export { default as HistoryLog } from './history_log/screen/HistoryLog';